import { Field, FieldArray, Formik } from 'formik';
import React from 'react'
import { Col, Form, Label, Row } from 'reactstrap';

const PorttoPort = () => {
    /** Formik object */
    const PorttoPortFormik = {
        initialValues: {
            porttoPort: [{
                departure_port: '',
                dep_eu_noneu: 'eu',
                arrival_port: '',
                arr_eu_noneu: 'eu',
                distance_between_ports: 0,
                ordered_speed: 0,
                voyage_days: 0,
                fo_consumption: 0,
                do_consumption: 0
            }]
        }
    }
    return (
        <Formik
            onSubmit={(values: any, actions: any) => {
                actions.setSubmitting(false);
            }}
            initialValues={PorttoPortFormik.initialValues}
        >
            {props => (
                <Form>
                    <FieldArray name='porttoPort'>
                        {({ push, remove }) => (
                            <>
                                {props && props?.values?.porttoPort.map((port: any, index: any) => {
                                    return (
                                        <>
                                            <Row className='mb-3'>
                                                <Col lg={4}>
                                                    <Label className="mb-0">Departure port</Label>
                                                    <Field
                                                        type="text"
                                                        name={`porttoPort.${index}.departure_port`} id="departure_port"
                                                        className="form-control"
                                                    />
                                                </Col>
                                                <Col lg={{ size: 1, offset: 1 }} className='mt-3'>
                                                    <Field
                                                        className="form-check-input mt-3"
                                                        type="radio"
                                                        name={`porttoPort.${index}.dep_eu_noneu`}
                                                        id="eu"
                                                        value="eu"
                                                        defaultChecked
                                                    />
                                                    <Label className="mt-3 ms-2" htmlFor="eu">EU</Label>
                                                </Col>
                                                <Col lg={2} className='mt-3'>
                                                    <Field
                                                        className="form-check-input mt-3"
                                                        type="radio"
                                                        name={`porttoPort.${index}.dep_eu_noneu`}
                                                        id="non_eu"
                                                        value="non_eu"
                                                    />
                                                    <Label className="mt-3 ms-2">Non EU</Label>
                                                </Col>
                                                <Col lg={{ size: 1, offset: 2 }}>
                                                    {index > 0 &&
                                                        <button type="button" className="btn justify_right">
                                                            <i className='dripicons-trash icon_s18'
                                                                onClick={(actions) => remove(index)} />
                                                        </button>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className='mb-3'>
                                                <Col lg={4}>
                                                    <Label className="mb-0">Arrival port</Label>
                                                    <Field
                                                        type="text"
                                                        name={`porttoPort.${index}.arrival_port`}
                                                        id="arrival_port"
                                                        className="form-control"
                                                    />
                                                </Col>
                                                <Col lg={{ size: 1, offset: 1 }} className='mt-3'>
                                                    <Field
                                                        className="form-check-input mt-3"
                                                        type="radio"
                                                        name={`porttoPort.${index}.arr_eu_noneu`}
                                                        id="eu"
                                                        value="eu"
                                                        defaultChecked
                                                    />
                                                    <Label className="mt-3 ms-2" htmlFor="eu">EU</Label>
                                                </Col>
                                                <Col lg={2} className='mt-3'>
                                                    <Field
                                                        className="form-check-input mt-3"
                                                        type="radio"
                                                        name={`porttoPort.${index}.arr_eu_noneu`}
                                                        id="non_eu"
                                                        value="non_eu"
                                                    />
                                                    <Label className="mt-3 ms-2">Non EU</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={4}>
                                                    <Label className="mb-0">Distance between the ports</Label>
                                                    <Field
                                                        type="text"
                                                        name={`porttoPort.${index}.distance_between_ports`}
                                                        id="distance_between_ports"
                                                        className="form-control"
                                                    />
                                                </Col>
                                                <Col lg={4}>
                                                    <Label className="mb-0">Ordered speed</Label>
                                                    <Field
                                                        type="text"
                                                        name={`porttoPort.${index}.distance_between_ports`}
                                                        id="distance_between_ports"
                                                        className="form-control"
                                                    />
                                                </Col>
                                                <Col lg={4}>
                                                    <Label className="mb-0">Total voyage days</Label>
                                                    <Field
                                                        type="text"
                                                        name={`porttoPort.${index}.voyage_days`}
                                                        id="voyage_days"
                                                        className="form-control"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <h6 className='mb-3'>Fuel consumption per day</h6>
                                                <Col lg={4}>
                                                    <Label className="mb-0">FO</Label>
                                                    <Field
                                                        type="text"
                                                        name={`porttoPort.${index}.fo_consumption`}
                                                        id="fo_consumption"
                                                        className="form-control"
                                                    />
                                                </Col>
                                                <Col lg={4}>
                                                    <Label className="mb-0">DO</Label>
                                                    <Field
                                                        type="text"
                                                        name={`porttoPort.${index}.do_consumption`}
                                                        id="do_consumption"
                                                        className="form-control"
                                                    />
                                                </Col>
                                            </Row>
                                            <hr className='mt-5 mb-5' />
                                            {index === (props.values.porttoPort.length - 1) &&
                                                <Label
                                                    className="link_color_blue"
                                                    onClick={() => push(
                                                        PorttoPortFormik.initialValues.porttoPort[0]
                                                    )}
                                                >
                                                    Add another port to port
                                                </Label>
                                            }
                                        </>
                                    )
                                })}
                            </>
                        )}
                    </FieldArray>
                </Form>
            )}
        </Formik>
    )
}

export default PorttoPort